import React from 'react';
import styled from 'styled-components';
import config from './config';

export default function ResponsibleGamblingComponent() {
  if (config.STATE.toLowerCase() === 'de') {
    return (
      <Container>
        <p>Responsible Gaming</p>
        <p>
          Must be 21+. Subject to regulatory licensing requirements. Know When To Stop Before You Start®. Gambling
          Problem? Call 1-800-GAMBLER.
        </p>
      </Container>
    );
  }
  return (
    <Container>
      <p>
        Must be 21 or older to gamble. (19+ in Ontario, Canada). Must be physically present in AZ, CO, DE, IL, IN, IA,
        KS, LA, MD, MI, MS, NV, NJ, NM, NY, NC, OH, Ontario (Canada), PA, RI, TN, VA, WA, WV, WY, Washington, DC, or
        Puerto Rico. Sports betting is void where prohibited by law. Know When To Stop Before You Start.® Gambling
        Problem? IL, KY, MD, NJ, OH, TN, VA, WV, PA (Affiliated with Harrah's Philadelphia): If you or someone you know
        has a gambling problem, crisis counselling and referral services can be accessed by calling 1-800-GAMBLER
        (1-800-426-2537) or MD: visit mdgamblinghelp.org; WV: visit 1800gambler.net; AZ: Call 1-800-NEXT-STEP; CO, DC,
        MN, MT, NV, ND, OR, RI, WY, KS (Affiliated with Kansas Crossing Casino): Call 1-800-522-4700; DE: Call
        1-888-850-8888 or visit deproblemgambling.org; IN: Call 1-800-9-WITH-IT; IA: Call 1-800-BETSOFF; LA (Licensed
        through Horseshoe Bossier City and Harrah’s New Orleans): Call 1-877-770-STOP; MA: Call 1-800-327-5050; __ MI:
        Call 1-800-270-7117; MS: Call 1-888-777-9696; NE: Call 1-833-BETOVER; NM: Call 1-888-696-2440; NC: Call
        877-718-5543 or visit morethanagame.nc.gov; WA (Affiliated with Muckleshoot Casino Resort): Call 1-800-547-6133;
        Ontario, Canada (Affiliated with Caesars Windsor): Visit connexontario.ca or call 1-866-531-2600 or text CONNEX
        to 247247; Puerto Rico: Call 1-800-981-0023; llame a la línea PAS de ASSMCA 1-800-981-0023. ©2023, Caesars
        Entertainment
      </p>
      <p>Gambling Problem?</p>
      <p>NY: Call 877-8-HOPENY or text HOPENY (467369); OH, PA: Call 1-800-GAMBLER</p>
    </Container>
  );
}

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.brand.foreground};
  color: ${({ theme }) => theme.colors.grey450};
  padding: 5rem 1.8rem 1.8rem 1.8rem;
  text-align: center;

  & > p {
    margin: 0;
  }
`;
